export default __webpack_public_path__ + "static/media/checkbox-empty.64cb26d5.svg";